import { createStore, applyMiddleware, } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist'



const persistconfiq = {
    key: "root",
    version: 1,
    storage
  };
const sagaMiddleware = createSagaMiddleware();

const persist = persistReducer(persistconfiq, rootReducer)

const store = createStore(persist, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootSaga);

export default store;